module.exports = __webpack_public_path__ + "img/pediatrie.fef87fa5.png";